import React from 'react';

function CardContentImageDate({ day, month }) {
  return (
    <div className="image__date">
      {day}
      {month && <span>{month}</span>}
    </div>
  );
}

export default CardContentImageDate;
